var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-6",
            attrs: {
              "form-context": _vm.formContext,
              label: "Beschreibung",
              property: "feeText",
              required: "",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Rechnungsdatum",
              property: "dateReceipt",
              required: "",
              type: "date",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("csp-desktop-info-card-element", {
            staticClass: "col-6",
            attrs: {
              "form-context": _vm.formContext,
              label: "Bemerkung",
              property: "paymentComment",
              type: "text",
            },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Bruttobetrag",
              property: "amount",
              required: "",
              type: "currency",
            },
            on: { input: _vm.updateAmountNet },
          }),
          _vm._v(" "),
          _c("csp-desktop-info-card-element", {
            staticClass: "col-3",
            attrs: {
              "form-context": _vm.formContext,
              label: "Teil- / Gutschrift (brutto)",
              property: "amountAdjustmentGross",
              type: "currency",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "ml-auto", attrs: { cols: "6" } },
            [
              _c(
                "b-row",
                [
                  _c("csp-desktop-info-card-element", {
                    staticClass: "col-6",
                    attrs: {
                      "form-context": _vm.formContext,
                      label: "Nettobetrag",
                      property: "amountNet",
                      type: "currency",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }